import { render, staticRenderFns } from "./sensitive.vue?vue&type=template&id=4196e5e4&scoped=true&"
import script from "./sensitive.vue?vue&type=script&lang=js&"
export * from "./sensitive.vue?vue&type=script&lang=js&"
import style0 from "./sensitive.vue?vue&type=style&index=0&id=4196e5e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4196e5e4",
  null
  
)

export default component.exports